const $$splitComponentImporter = () => import('/app/src/routes/drivers.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/drivers")({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});